import {
    CREATE_CREDIT_NOTE_EMAIL_REQUEST,
    CREATE_CREDIT_NOTE_EMAIL_SUCCESS,
    CREATE_CREDIT_NOTE_EMAIL_ERROR
  } from "../actions/types";

  export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
      case CREATE_CREDIT_NOTE_EMAIL_REQUEST:
        return {
          loading: true,
        };
      case CREATE_CREDIT_NOTE_EMAIL_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case CREATE_CREDIT_NOTE_EMAIL_ERROR:
        return {
          ...state,
          loading: false,
        };
      default:
        return state;
    }
  }
  